import { useEffect, type ReactNode } from "react";
import { setOnUnauthorized } from "@/api/axios";
import { useAppDispatch } from "@/store";
import { fetchCurrentUser, clearAuth } from "@/store/authSlice";
import { fetchCategories } from "@/store/categoriesSlice";

export function AuthInit({ children }: { children: ReactNode }) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    setOnUnauthorized(() => dispatch(clearAuth()));
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchCurrentUser());
    dispatch(fetchCategories());
  }, [dispatch]);

  return <>{children}</>;
}
